import React, { useContext, useEffect, useState } from "react";
import RenderRazorpay from "./RenderRazorPay";
import axios from 'axios';
import '../cart/carts.css';
import { CartContext } from "../cart/ContextProvider";

function PayButton() {



 
    const {totalPrice,displayRazorpay,setDisplayRazorpay} = useContext(CartContext);
    const [orderDetails, setOrderDetails] = useState({
      orderId: null,
      currency: null,
      amount: null,
    });
  
    const handleCreateOrder = async (currency) => {
      const response = await axios.post('https://jackpotbackend.vercel.app/order',
        {
          amount: Math.floor(totalPrice+(0.05 * totalPrice)), //convert amount into lowest unit. here, Dollar->Cents
          currency: currency,
        }
      );
  
      if (response && response.data.order_id) {

        setOrderDetails({
          orderId: response.data.order_id,
          currency: response.data.currency,
          amount: response.data.amount,
        });
        console.log(orderDetails.orderId);
        setDisplayRazorpay(true);
      };
  
    }

    return (
        <div>
          <button className="pay-button"
            onClick={() => handleCreateOrder('INR')}
          >Place Order
          </button>
              
        {displayRazorpay && (
        <RenderRazorpay
          amount={orderDetails.amount}
          currency={orderDetails.currency}
          orderId={orderDetails.orderId}
          keyId={process.env.REACT_APP_RAZORPAY_KEY_ID}
          keySecret={process.env.REACT_APP_RAZORPAY_KEY_SECRET}
        />
      )}


    </div>
  );

}

export default PayButton;